import React, { useState, useEffect } from "react";
import "./Swan.css";
import swan1 from "../images/swan1.jpeg";
import swan2 from "../images/swan2.jpeg";

function Swan() {
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  // Fetch comments from MongoDB
  useEffect(() => {
    fetch("http://localhost:5000/api/swan-comments")
      .then((res) => res.json())
      .then((data) => setComments(data))
      .catch((err) => console.error("Error fetching comments:", err));
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit new comment to MongoDB
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("http://localhost:5000/api/swan-comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      setComments([data, ...comments]);
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("Error submitting comment:", err);
    }
  };

  // Like comment
  const handleLike = async (id) => {
    try {
      const res = await fetch(`http://localhost:5000/api/swan-comments/${id}/like`, {
        method: "PUT",
      });
      const updated = await res.json();
      setComments(comments.map((c) => (c._id === id ? updated : c)));
    } catch (err) {
      console.error("Error liking comment:", err);
    }
  };

  return (
    <div className="swan-page">
      <main className="swan-content">
        <section className="swan-hero">
          <h2>Swans</h2>
          <p>
            Swans are large waterfowl known for their grace and beautiful white plumage.
          </p>
        </section>

        <section className="swan-images">
          <img src={swan1} alt="Swan 1" />
          <img src={swan2} alt="Swan 2" />
        </section>

        <section className="swan-info">
          <h3>Locations</h3>
          <p>
            Swans are found mostly in temperate regions of North America, Europe, and Asia,
            usually on lakes and rivers.
          </p>
        </section>

        {/* Comments Section */}
        <section id="comments" className="comments-section">
          <h2>Community Comments</h2>

          <form className="comment-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email (optional)"
              value={formData.email}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Write your comment..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Post Comment</button>
          </form>

          <div className="comment-list">
            {comments.length === 0 ? (
              <p className="no-comments">No comments yet. Be the first!</p>
            ) : (
              comments.map((c) => (
                <div key={c._id} className="comment">
                  <div className="comment-header">
                    <div className="avatar">{c.name.charAt(0).toUpperCase()}</div>
                    <div>
                      <h4>{c.name}</h4>
                      <small>{new Date(c.date).toLocaleString()}</small>
                    </div>
                  </div>

                  <p className="comment-text">{c.message}</p>

                  <div className="comment-actions">
                    <button onClick={() => handleLike(c._id)}>👍 {c.likes}</button>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Swan;

